import { Box, Button, Grid, Modal, Stack, Typography } from "@mui/material";
import { Container } from "../../components/styledComponent/Common";
import styled from "styled-components";
import BreadCrum from "../../components/layout/BreadCrumb";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { endpoints } from "../../api/endpoints";
import { useCrudForm } from "../../api/useCrudForm";
import { Check, Verified } from "@mui/icons-material";
import { cancelStyle } from "../../components/modal/cancelModalStyle";
import { toast } from "react-toastify";
import { AppContext } from "../../contexts/AppContext";
import moment from "moment";
import { KeyValueText, KeyTxt } from "../../components/styledComponent/Common";
import CustomerInfoText from "../../components/customer/customerInfoText";
import { LoadingButton } from "@mui/lab";

const LayoutNewCustomerReg = styled(Box)`
    padding: 10px 0;
`;

const LockerLocationDetails = () => {
    const [locationDetails, setLocationDetails] = useState<any | null>();
    const [isApproved, setIsApproved] = useState<boolean>(false);
    const { id } = useParams();
    const [locationLoading, setLocationLoading] = useState<boolean>(true);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const isMainTable = queryParams.get('isMainTable') ?? 'false';
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    const { get, edit } = useCrudForm();
    const { user } = useContext(AppContext)

    useEffect(() => {
        if (id) {
            setLocationLoading(true)
            get({
                endpoints: `${endpoints.lockerLocation.get({ id: parseInt(id), isMainTable: isMainTable })}`,
                onSuccess: (data: any) => {
                    const locationInfo = data.data.existingData ?? data.data.tempData
                    const mapLocationInfo = Object.keys(locationInfo).reduce((acc: any, key: any) => Object.assign(acc, { [key]: locationInfo[key] !== '' ? locationInfo[key] : null, ['temp' + key]: data.data.tempData !== null ? data.data.tempData[key] !== '' ? data.data.tempData[key] : null : undefined, ['isSame' + key]: data.data.tempData == null || data.data.existingData == null ? true : locationInfo[key] === data.data.tempData[key] }), {})
                    setLocationDetails(mapLocationInfo)
                    setLocationLoading(false)
                },
                onError: (error: any) => {
                    toast.error(error?.message ?? error)
                    navigate('/locker-location')
                    setLocationLoading(false)
                    console.log(error)
                }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    const handleClose = () => {
        setOpen(false);
    };

    const handleApproveLocation = () => {
        if (id) {
            setLocationLoading(true)
            edit({
                endpoints: endpoints.lockerLocation.approved({ locationId: parseInt(locationDetails?.tempid ?? id) }),
                onSuccess: (data: any) => {
                    toast.success(data?.message ?? 'Successfully Approved', { style: { background: '#3150A1' } })
                    navigate('/locker-location')
                    setLocationLoading(false)
                },
                onError: (error: any) => {
                    toast.error(error?.message ?? error)
                    setLocationLoading(false)
                },
                values: {}
            })
        }
    }

    useEffect(() => {
        setIsApproved(locationDetails?.tempisApproved !== undefined ? locationDetails?.tempisApproved : locationDetails?.isApproved !== undefined ? locationDetails?.isApproved : false)
    }, [locationDetails])

    return (
        <Box>
            <TopBreadcrumbs />

            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
                <Typography variant="h5" component="h2" mt={3} fontWeight={600}>Locker Location Details</Typography>
                {
                    !locationLoading ? <Stack direction="row" gap={2} alignItems="center">
                        {
                            isApproved === true ? <Button variant="contained" sx={{ padding: '4px 8px', backgroundColor: '#07bc0c', marginLeft: '16px', '&:hover': { backgroundColor: '#07bc0c', } }}>
                                <Verified />
                                <Typography style={{ fontSize: '14px', marginLeft: '4px' }}>Verified</Typography>
                            </Button> : (user?.role)?.toLowerCase() === 'admin' || (user?.role)?.toLowerCase() === 'checker' ? <Button onClick={() => setOpen(true)} variant="contained" sx={{ padding: '4px 8px', backgroundColor: '#3150A1', marginLeft: '16px', '&:hover': { backgroundColor: '#3150A1', } }}>
                                <Check />
                                <Typography style={{ fontSize: '14px', marginLeft: '4px' }}>Verify</Typography>
                            </Button> : null
                        } </Stack> : null
                }
            </Stack>

            <Stack direction="row" justifyContent="right" gap={2} alignItems="center" mb={1}>
                <Box sx={{ display: "flex", gap: "10px", justifyContent: 'center', alignItems: 'center' }}>
                    <Box height="10px" width="10px" sx={{ backgroundColor: '#3150A1', padding: '6px' }}>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: 'start', alignItems: 'start' }}>
                        <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                            <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Created By:</Typography>
                            <small style={{ fontSize: "14px" }}>{locationDetails?.createdUser ?? "N/A"}</small>
                        </Box>
                        <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                            <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Created Date:</Typography>
                            <small style={{ fontSize: "14px" }}>{locationDetails?.createdDate ? moment(locationDetails?.createdDate).format('YYYY/M/D') : "N/A"}</small>
                        </Box>
                    </Box>
                </Box>
                <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                    <Box height="10px" width="10px" sx={{ backgroundColor: '#f1c40f', padding: '6px' }}>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: 'start', alignItems: 'start' }}>
                        <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                            <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Updated By:</Typography>
                            <small style={{ fontSize: "14px" }}>{locationDetails?.updatedUser ?? "N/A"}</small>
                        </Box>
                        <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                            <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Updated Date:</Typography>
                            <small style={{ fontSize: "14px" }}>{locationDetails?.updatedDate ? moment(locationDetails?.updatedDate).format('YYYY/M/D') : "N/A"}</small>
                        </Box>
                    </Box>
                </Box>
                <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                    <Box height="10px" width="10px" sx={{ backgroundColor: '#07bc0c', padding: '6px' }}>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: 'start', alignItems: 'start' }}>
                        <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                            <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Verified By:</Typography>
                            <small style={{ fontSize: "14px" }}>{locationDetails?.verifiedUser ?? "N/A"}</small>
                        </Box>
                        <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                            <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Verified Date:</Typography>
                            <small style={{ fontSize: "14px" }}>{locationDetails?.verifiedDate ? moment(locationDetails?.verifiedDate).format('YYYY/M/D') : "N/A"}</small>
                        </Box>
                    </Box>
                </Box>
            </Stack>

            <LayoutNewCustomerReg>
                <Container sx={{ width: "100%" }}>
                    <Grid container spacing={2}>
                        <Grid xs={12} item>
                            <Box>
                                <Grid container spacing={2}>
                                    {
                                        locationDetails?.tempapprovalStatus === 3 ? <Grid item xs={12} md={12}>
                                            <Typography sx={{ color: "red", fontWeight: "700", fontSize: "10px" }}>
                                                Locker location is set to delete. Note: This action cannot be undone if verified.
                                            </Typography>
                                        </Grid> : null
                                    }
                                    <Grid item xs={12} md={12}>
                                        <KeyValueText>
                                            <KeyTxt>Branch:</KeyTxt>
                                            <CustomerInfoText loading={locationLoading} isSame={!locationDetails?.isSamebranchName} value={locationDetails?.branchName} tempValue={locationDetails?.tempbranchName} />
                                        </KeyValueText>
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <KeyValueText>
                                            <KeyTxt>Location Name:</KeyTxt>
                                            <CustomerInfoText loading={locationLoading} isSame={!locationDetails?.isSamename} value={locationDetails?.name} tempValue={locationDetails?.tempname} />
                                        </KeyValueText>
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <KeyValueText>
                                            <KeyTxt>Code:</KeyTxt>
                                            <CustomerInfoText loading={locationLoading} isSame={!locationDetails?.isSamecode} value={locationDetails?.code} tempValue={locationDetails?.tempcode} />
                                        </KeyValueText>
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <KeyValueText>
                                            <KeyTxt>Description:</KeyTxt>
                                            <CustomerInfoText loading={locationLoading} isSame={!locationDetails?.isSamedescription} value={locationDetails?.description} tempValue={locationDetails?.tempdescription} />
                                        </KeyValueText>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </LayoutNewCustomerReg>

            <Modal
                open={open}
                onClose={handleClose}
            >
                <Box sx={{ ...cancelStyle, width: 200 }} mt={10} textAlign={'center'}>
                    <Stack spacing={2} alignItems='center' justifyContent={'center'}>
                        <Typography component='div' variant='h5'  >Are you sure you want to approve?</Typography>
                        <Typography variant='body2' component='span' sx={{ marginTop: '10px' }}>If cancel, all the unsaved work will be discarded.</Typography>
                        <Stack direction={'row'} gap={2} >
                            <LoadingButton loading={locationLoading} onClick={handleApproveLocation} variant='contained' color='success'>Yes</LoadingButton>
                            <Button onClick={handleClose} variant='contained' color='error'>Cancel</Button>
                        </Stack>
                    </Stack>
                </Box>
            </Modal>
        </Box>
    );
}

const TopBreadcrumbs = () => {
    const location = [{ name: "Locker Location", to: "/locker-location" }, { name: "Details" }]
    return (
        <BreadCrum location={location} />
    );
}

export default LockerLocationDetails;